import './app.css';

import '@babel/polyfill';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* meta [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM META IN JS] */
// import meta from './js/meta.json';

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// import data from './js/data.json';

const analyticsEvent = require('./js/viscom/viscomjs/analytics/analyticsEvent');
analyticsEvent('Page', 'load', 'Load');


/* fonts */
import WebFont from 'webfontloader';

WebFont.load({
    // GOOGLE FONTS
    google: {
        families: ['Open+Sans:300,400,700,300i,400i,700i:cyrillic,cyrillic-ext,latin-ext', 'Cormorant+Garamond:400,700:cyrillic,cyrillic-ext,latin-ext']
    }
});


import lazySizes from 'lazysizes';

// All the listeners must be added after the first vue app render ->

/* lazy loading (https://github.com/aFarkas/lazysizes) */
/* EXAMPLE:
 <!-- non-responsive: -->
 <img data-src="image.jpg" class="lazyload">

 <!-- responsive example with automatic sizes calculation: -->
 <img
 data-sizes="auto"
 data-src="image2.jpg"
 data-srcset="image1.jpg 300w,
 image2.jpg 600w,
 image3.jpg 900w"
 class="lazyload">

 <!-- iframe example -->
 <iframe frameborder="0"
 class="lazyload"
 allowfullscreen=""
 data-src="//www.youtube.com/embed/ZfV-aYdU4uE">
 </iframe>
 */
lazySizes.init();

{


    /* analytics */
    require('./js/viscom/viscomjs/analytics/elementsTracking');
    // Could be actualized by method update:
    // elementsTracking.update();


    /* share */
    require('./js/viscom/boss/soccers/components/shareListWithTrigger');

    const startProject = () => {
        const preloader = require('./js/viscom/boss/soccers/load/Preloader');
        const PIXIPreload = require('./js/viscom/boss/soccers/load/PIXIPreload');
        const manifest = require('./js/viscom/boss/soccers/load/Manifest');
        const SizeMode = require('./js/viscom/boss/soccers/utils/SizeMode');

        const BOSSWatermark = require('./js/viscom/boss/soccers/BOSSWatermarkSingleton');
        const Constants = require('./js/viscom/boss/soccers/Constants');
        BOSSWatermark.init(Constants.BOSSWatermarkRefHeight * Constants.BOSSWatermarkPeriodRatio).start();

        const startLoadTime = new Date().getTime();
        const delay = isProd ? 1500 : 1000;

        PIXIPreload(SizeMode(true) === 'horizontal' ? manifest.manifest : manifest.mobileManifest, {baseUrl: manifest.baseUrl}, preloader.update).then(() => {
            const t = new Date().getTime();
            const Project = require('./js/viscom/boss/soccers/ProjectSingleton');
            preloader.update({
                progress: 100
            });
            setTimeout(() => {
                Project.init();
                setTimeout(() => {
                    Project.start();

                    setTimeout(() => {
                        preloader.destroy();
                        // console.clear();
                    }, 300);
                }, 300);
            }, Math.max(0, delay - (t - startLoadTime)));

        }, () => {
            // NO IMAGE LOADED
        });

    };

    startProject();
}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}







// WEBPACK FOOTER //
// ./app.js